<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">


    <!--<div>-->
      <!--<router-link to="">-->
     <!--<span style="display: flex;justify-content: center;width: 100%;padding: 30px 0 10px" class="base-color"-->
           <!--v-show="!isCollapse">-->
          <!--<img src="https://ss-platform-test.shijicloud.com/shop-xd-web/images/shiji-logo-white.png"-->
               <!--style="width:56px;height: 30px;">-->
    <!--</span>-->
        <!--<div v-show="!isCollapse" style="text-align: center;color: #fff; letter-spacing: 3px;font-size: 15px;padding-bottom:10px;background-color: #1a65ba;font-family: AdobeHeitiStd-Regular, AdobeHeitiStd;-->
<!--font-weight: 600;">{{$t('login.title')}}-->
        <!--</div>-->

      <!--</router-link>-->
    <!--</div>-->

    <!--    unique-opened=true-->
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
    >
      <sidebar-item v-for="route in permission_routes" :key="route.name" :item="route"
                    :base-path="route.path"></sidebar-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
  import {mapGetters} from 'vuex'
  import SidebarItem from './SidebarItem'
  import variables from '@/styles/variables.scss'

  export default {
    components: {SidebarItem},
    computed: {
      ...mapGetters([
        'sidebar',
        'permission_routes'
      ]),
      routes() {
        // console.log('this.$router.options.routes',this.$router.options.routes)
        return this.$router.options.routes
      },
      isCollapse() {
        return !this.sidebar.opened
      },
      variables() {
        return variables
      },
    },
    created() {
      // console.log('permission_routes',this.permission_routes)
    }
  }

</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue